import { OptionalNullableDisplayNameSchema } from '../../../../../../lib/valibot/schema/DisplayName.type'
import { literal, object, optional, type InferOutput } from 'valibot'
import { Engine } from '../../../../engine/Engine.type'
import { Player } from '../../../../player/Player.type'
import { PlayerColorSchema } from '../../../../player/PlayerColor.type'
import { PlayerId, PlayerIdSchema } from '../../../../player/PlayerId'
import { PlayerMoneySchema } from '../../../../player/PlayerMoney.type'
import { assign } from '../../../../util/Object'
import type { ActionLog } from '../../ActionLog.type'
import { ActionType } from '../ActionType'

export const PatchPlayerActionDataSchema = object({
  dname: OptionalNullableDisplayNameSchema,
  dname_placeholder: OptionalNullableDisplayNameSchema,
  money: optional(PlayerMoneySchema),
  color1: optional(PlayerColorSchema),
  color2: optional(PlayerColorSchema),
})

export type PatchPlayerActionData = InferOutput<typeof PatchPlayerActionDataSchema>

export const PatchPlayerActionSchema = object({
  type: literal(ActionType.Map.PatchPlayer),
  player_id: PlayerIdSchema,
  data: PatchPlayerActionDataSchema,
})

export type PatchPlayerAction = InferOutput<typeof PatchPlayerActionSchema>

export function createPatchPlayerAction(
  player_id: PlayerId,
  data: PatchPlayerActionData
): PatchPlayerAction {
  return {
    type: ActionType.Map.PatchPlayer,
    player_id,
    data,
  }
}

export async function handlePatchPlayerAction(
  engine: Engine,
  action: PatchPlayerAction,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  actionLog: ActionLog
): Promise<void> {
  const { player_id, data } = action
  engine.state.players.forEach((player: Player): void => {
    if (player.id === player_id) {
      assign(player, data)
    }
  })
}
